import { useIntl } from '@capsicum/common';

export const useWCPledgeCardTexts = () => {
	const { $t } = useIntl();

	return {
		// TODO: Add the total amount of teams when we have the actual data and end date
		WCPledgeCardFirstSubtitle: $t('worldChampionshipPledge.entryPoint.cardFirstSubtitle', {
			totalTeams: 'total teams'
		}),
		WCPledgeCardRibbonClosed: $t('worldChampionshipPledge.entryPoint.cardRibbonClosed'),
		WCPledgeCardRibbonOpened: $t('worldChampionshipPledge.entryPoint.cardRibbonOpened'),
		WCPledgeCardSecondSubtitle: $t('worldChampionshipPledge.entryPoint.cardSecondSubtitle', {
			endDate: 'end date'
		}),
		WCPledgeCardTitle: $t('worldChampionshipPledge.entryPoint.cardTitle'),
		WCPledgeSectionTitle: $t('worldChampionshipPledge.entryPoint.sectionTitle')
	};
};
